import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const AuthGuard = ({ children }) => {
  const userDetail = useSelector((state) => state.User.UserDetail);

  if (userDetail) {
    return children;
  } else {
    return <Navigate to="/" />;
  }
};

export default AuthGuard;
